const doc = [({"en":({"js":({"admin":({"teams":({"index":({"the_team_was_deleted":"The team was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;